import React from 'react'
import PropTypes from 'prop-types'
import Sidebar from '../SideBar/SideBar'
import NetworkStatusAlert from '../NetworkStatusAlert/NetworkStatusAlert'
import AlertModal from '../AlertModal/AlertModal'
import useAlert from '../../hooks/useAlert'
import CustomLoader from '../user/includes/CustomLoader'
import useGlobalLoading from '../../hooks/useGlobalLoading'
import LoginNetworkStatusAlert from '../LoginNetworkStatusAlert/LoginNetworkStatusAlert'
import MaintenanceModeAlert from '../MaintenanceModeAlert/MaintenanceModeAlert'

const UserLayout = ({ children, hasSideBar }) => {
    const {
        handleChangeOpen,
        message,
        title,
        type,
        onDone,
        textOk,
        onCancel,
        textCancel,
        open,
    } = useAlert()
    const { isLoading, text } = useGlobalLoading()

    return (
        <>
            {isLoading && <CustomLoader text={text} />}
            <AlertModal
                type={type}
                message={message}
                isOpen={open}
                title={title}
                onDone={onDone}
                onCancel={onCancel}
                textOk={textOk}
                textCancel={textCancel}
                setIsOpen={handleChangeOpen}
            />
            {!hasSideBar && <LoginNetworkStatusAlert />}
            {hasSideBar ? (
                <div className="w-screen h-screen max-h-screen overflow-auto flex flex-col items-start justify-start relative">
                    <NetworkStatusAlert />
                    <MaintenanceModeAlert />
                    <div className="w-full h-full overflow-auto flex flex-col items-start justify-start md:flex-row">
                        <Sidebar />
                        {/* Content */}
                        <main className="w-full h-full pt-14 md:pt-0 bg-grayBackground overflow-auto">
                            {children}
                        </main>
                    </div>
                </div>
            ) : (
                <>{children}</>
            )}
        </>
    )
}

UserLayout.propTypes = {
    children: PropTypes.node,
    hasSideBar: PropTypes.bool,
}

export default UserLayout
